import { z } from "zod";
import {
  PricingTierSchema,
  createPricingTierSchema,
  updatePricingTierSchema,
} from "@/lib/validations/products/pricing-tier";

/** Fields that can be edited in a pricing tier */
export type PricingTierEditableField = "name" | "description" | "isDefault";

/** Interface defining permissions for pricing tier fields */
export interface PricingTierFieldPermissions {
  editable: PricingTierEditableField[];
  viewable: PricingTierEditableField[];
}

/** Fields that can be used for sorting pricing tiers */
export const PricingTierSortable = ["name", "isDefault", "created"] as const;
export type PricingTierSortField = (typeof PricingTierSortable)[number];

/** Complete pricing tier type with all fields */
export type PricingTier = z.infer<typeof PricingTierSchema>;

/** Type for creating a new pricing tier */
export type CreatePricingTierInput = z.infer<typeof createPricingTierSchema>;

/** Type for updating an existing pricing tier */
export type UpdatePricingTierInput = z.infer<typeof updatePricingTierSchema>;

/** Pricing tier with relationships */
export interface PricingTierWithRelations extends PricingTier {
  companies?: Array<{ id: string; name: string }>;
}

/** Simple pricing tier type for basic lists */
export interface SimplePricingTier {
  id: string;
  name: string;
  isDefault: boolean;
}
